import {createEntityAdapter} from '@reduxjs/toolkit'
import {IBusinessUnit} from '../../types'

export const businessUnitsAdapter = createEntityAdapter<IBusinessUnit>()